import { render, staticRenderFns } from "./huFooter.vue?vue&type=template&id=a1555f4c&scoped=true&"
import script from "./huFooter.vue?vue&type=script&lang=js&"
export * from "./huFooter.vue?vue&type=script&lang=js&"
import style0 from "./huFooter.vue?vue&type=style&index=0&id=a1555f4c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1555f4c",
  null
  
)

export default component.exports